// TODO get api token from Wizart and set the value
const api_token = 'VMmkWUjrJ0qRcnwhHmM9ChcuFJQ23KtUE9EAQh6dbmlCSkPDTFB2qzeZY9Nv';
// please do not change the server address
const server_address = 'https://pim-client.wizart.ai';

// bba (back button action) param is used to add back button to wizart component
const fittingRoomEndpoint = server_address
	+ '/fitting-room'
	+ '?api_token=' + api_token
	+ '&bba=true'
	;

function openFittingRoom(searchQuery) {
	const componentEndpoint = searchQuery ? fittingRoomEndpoint + searchQuery : fittingRoomEndpoint;

	let fittingRoomObject = document.getElementById('wizart-fitting-room-object');
	const fittingRoomObjectContainer = fittingRoomObject.parentElement;

	fittingRoomObject.setAttribute('src', componentEndpoint);
	// object clonning is necessary as some browsers does not render "object" twice after changing data attribute
	const clonnedFittingRoomObject = fittingRoomObject.cloneNode(true);

	fittingRoomObjectContainer.appendChild(clonnedFittingRoomObject);
	fittingRoomObject.remove();

	clonnedFittingRoomObject.classList.add('active');

	// should be added to avoid duplicating scrollbars
	document.getElementsByTagName('html')[0].style.overflow = 'hidden';
}

function openSpecificFittingRoom(vendorCode) {
	disclaimerPopup();

	// query can be updated to search for necessary article
	const articleSearchQuery = '&article_query='
			+ '{\"vendor_code\": \"'
			+ vendorCode
			+ '\"}'
	;

	openFittingRoom(articleSearchQuery);

    document.getElementsByClassName('theme__header')[0].style.visibility = 'hidden';
    document.getElementsByClassName('header__wrapper')[0].style.display = 'none';
    document.getElementsByClassName('announcement__wrapper')[0].style.visibility = 'hidden';
    document.getElementById('cart-bar').style.visibility = 'hidden';
}


// bba event - fired when back button is clicked at wizart component
window.addEventListener('message', function (event) {
	if (~event.origin.indexOf(server_address)) {
		// exactly 'close_overlay' as it's sent from wizart component
		if (event.data === 'close_overlay') {
			// return overflow of target page to initial state
			document.getElementsByTagName('html')[0].style.overflow = 'auto';

		  document.getElementById('wizart-fitting-room-object').classList.remove('active');
          document.getElementsByClassName('theme__header')[0].style.visibility = 'visible';
          document.getElementsByClassName('announcement__wrapper')[0].style.visibility = 'visible';
          document.getElementsByClassName('header__wrapper')[0].style.display = 'block';
          document.getElementById('cart-bar').style.visibility = 'visible';
		}

		if (event.data && event.data.eventName === 'wizart_shopping_cart') {
			// here you can process the data that comes from the shopping cart after clicking go_to_shop
		}
	}

});